// ============================================================================
// CHANGO V5.0 — Role permission constants (frontend half of §20 坑 #17)
// ============================================================================
// These lists MIRROR the backend's `stripSensitiveForSales` and `roleGuard`
// allowlists. Keep them in sync — if you change one, change the other.
//
// Defense in depth:
//   1. Backend strips sensitive fields on the way out of every JSON response.
//   2. Frontend refuses to RENDER those fields even if they somehow arrive
//      (e.g., a pre-existing cached page, a misconfigured proxy, a future
//      bug in the backend filter).  Double guard.
// ============================================================================

export const ROLES = Object.freeze(['boss', 'finance', 'sales']);

// Keys whose values MUST NEVER be shown to role='sales'. Matching is done via
// toLowerCase()+includes() — pick the tokens so they catch any legitimate
// variant (profit_margin / gross_profit / etc.) without false positives.
export const SENSITIVE_KEY_TOKENS = Object.freeze([
  'cost',
  'profit',
  'margin',
  'expense',
  'rebate',
  'refund_amount',
  'purchase_price',
  'supplier_cost',
  'capital_cost'
]);

export function isSensitiveKey(key) {
  if (typeof key !== 'string') return false;
  const k = key.toLowerCase();
  return SENSITIVE_KEY_TOKENS.some((token) => k.includes(token));
}

// Role → URL prefix allowlist for client-side navigation warnings. Backend
// still enforces authoritatively; this just prevents a sales user from even
// seeing the link in the nav.
export const ROLE_NAV_DENY = Object.freeze({
	  sales: [
	    '/reports/profit',
	    '/reports/margin',
	    '/reports/cost',
	    '/app/billing'               // D7: SKU / order pages are boss+finance only
	  ],
	  finance: [
	    '/app/settings'             // boss-only
	  ],
  boss: []
});

export function canAccessPath(role, path) {
  if (!role) return false;
  const denies = ROLE_NAV_DENY[role] || [];
  return !denies.some((p) => path.startsWith(p));
}
